import React from 'react'
import OrderIndicator from 'components/OrderIndicator'
import moment from 'moment'
import 'moment/locale/tr'

moment.locale("tr");


const Payouts = ({ data }) => {
  // Helper function to render transfer reference
  const renderTransferReference = (reference) => {
    if (!reference) return "-";
    
    if (reference.startsWith("USDT-OK-")) {
      const txid = reference.substring(8); // Remove "USDT-OK-" prefix
      const truncatedTxid = txid.length > 12
        ? `${txid.substring(0, 6)}...${txid.substring(txid.length - 6)}`
        : txid;
      
      return (
        <a
          href={`https://tronscan.org/#/transaction/${txid}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300 underline"
          title={txid}
        >
          {truncatedTxid}
        </a>
      );
    }
    
    return <span className="truncate">{reference}</span>;
  };

  return (
    <div className="overflow-x-auto p-4">
      <table className="min-w-full divide-y-2 divide-gray-200 text-sm">
        <thead className="">
          <tr>
            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              Tutar
            </th>

            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              Hesap Sahibi
            </th>
            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              İban
            </th>
            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              İşlem Tarihi
            </th>
            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              İşlem Durumu
            </th>
            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              Ref
            </th>

          </tr>
        </thead>

        <tbody className="divide-y divide-gray-200">
          {data?.map((data) => (
            <tr key={data.id}>
              <td className="whitespace-nowrap px-4 py-2 font-medium text-white-100">
                {data.amount_try}₺
              </td>

              <td className="whitespace-nowrap px-4 py-2 text-white-100">
                {data.holder_name}
              </td>
              <td className="whitespace-nowrap px-4 py-2 text-white-100">
                {data.iban}
              </td>
              <td className="whitespace-nowrap px-4 py-2 text-white-100">
                {moment(data.created_at).format('Do MMMM YYYY, H:mm:ss')}
              </td>
              <td className="whitespace-nowrap px-4 py-2 text-white-100">
                {data.status === "completed" ? (
                  <OrderIndicator color="green">Aktarım Yapıldı.</OrderIndicator>
                ) : data.status === "pending_transfer" ? (
                  <OrderIndicator color="yellow">Aktarım Bekliyor.</OrderIndicator>
                ) : data.status === "failed" ? (
                  <OrderIndicator color="red">
                    Aktarım Reddedildi.
                  </OrderIndicator>
                ) : (
                  <OrderIndicator color="red">No Data</OrderIndicator>
                )}
              </td>
              <td className="whitespace-nowrap px-4 py-2 text-white-100">
                {renderTransferReference(data.transfer_reference)}
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Payouts;
